export const ACTION_LOG_STATUS = {
  CHANGED: {
    id: 1,
    text: 'value_changed',
    class: 'value-changed',
  },
  DELETED: {
    id: 2,
    text: 'value_deleted',
    class: 'value-deleted',
  },
  ADDED: {
    id: 3,
    text: 'value_added',
    class: 'value-added',
  },
}